var _path, _path2, _path3, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeviceMotorLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    enableBackground: "new 0 0 60 60",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M30.6,9.8c11.1,0,20.2,9.1,20.2,20.2s-9.1,20.2-20.2,20.2S10.5,41,10.5,29.9S19.6,9.8,30.6,9.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "black",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M11.7,37H7.5V23h4.2l0,0c-0.8,2.2-1.2,4.5-1.2,7C10.5,32.4,10.9,34.8,11.7,37L11.7,37z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "black",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M49.5,37c0.8-2.2,1.3-4.6,1.3-7.1c0-2.4-0.4-4.8-1.2-7l0,0h4.2v14L49.5,37L49.5,37z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M23.4,36.2l0-11.5h2.5l4.8,7.1l4.8-7.1h2.5v11.5h-2.8v-6.7l-3.8,5.5H30l-3.8-5.7l0,6.9H23.4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceMotorLight);
export default __webpack_public_path__ + "static/media/device-motor-light.6f2a3baaa58bd7a3f08ef0fce1f6ef39.svg";
export { ForwardRef as ReactComponent };